import { Button } from "@ui/Button";
import { Tooltip, TooltipTrigger } from "@ui/Tooltip";
import { createSignal } from "solid-js";
import type { ListBoardItemResponse } from "@/client/types.gen";
import { shareBoardUrl } from "./videoPanel/shareBoard";

export const ShareBoardButton = (props: { board: ListBoardItemResponse }) => {
	const [sharing, setSharing] = createSignal(false);
	const disabled = () => props.board.privacy === "private" || sharing();
	const tip = () =>
		disabled() && props.board.privacy === "private"
			? "This board is private and cannot be shared"
			: "Share Board";

	const handleShare = async () => {
		if (disabled()) {
			return;
		}

		setSharing(true);
		try {
			await shareBoardUrl(props.board);
		} catch (error) {
			console.error("Failed to share board:", error);
		} finally {
			setSharing(false);
		}
	};

	return (
		<TooltipTrigger>
			<Button
				disabled={disabled()}
				variant="tertiary"
				style={{ width: "2rem", height: "2rem" }}
				symbol="ios_share"
				onClick={handleShare}
			></Button>
			<Tooltip>{tip()}</Tooltip>
		</TooltipTrigger>
	);
};
